// extracted by mini-css-extract-plugin
export default {"title":"ModalHeader_title__ZoWVy","close":"ModalHeader_close__L5k58"};